export enum MetaDataKey {
  templateId,
  automationId,
  answerId,
  forFollower,
}
export interface MetaData {
  key: MetaDataKey
  value: any | null | undefined
}
